import React, { useEffect } from "react";
import Meta from "./global/meta";
import News from "./global/news";
import WhyCallSpeedoc from "./global/whyCallSpeedoc";
import WithSpeedoc from "./global/withSpeedoc";
import HowToRequest from "./global/howToRequest";
import { trackPage } from "../services/analytics";

export default function ClinicNearMe(props) {
  useEffect(() => {
    trackPage();
  }, []);

  return (
    <div id="clinicNearMe">
      <Meta seo={{ description: "Find a clinic near me" }} title="Clinic Near Me" />
      <meta name="prerender-status-code" content="301" />
      <meta name="prerender-header" content="Location: //speedoc.com" />
      <News />
      <WhyCallSpeedoc />
      <WithSpeedoc />
      <HowToRequest />
    </div>
  );
}
